import { Component } from '@angular/core';

@Component({
  selector: 'app-projects-navigation',
  templateUrl: './projects-navigation.component.html',
  styleUrls: ['./projects-navigation.component.scss'],
})
export class ProjectsNavigationComponent {}
